import { render, staticRenderFns } from "./StepEditFile.vue?vue&type=template&id=226bc17b&scoped=true&"
import script from "./StepEditFile.vue?vue&type=script&lang=js&"
export * from "./StepEditFile.vue?vue&type=script&lang=js&"
import style0 from "./StepEditFile.vue?vue&type=style&index=0&id=226bc17b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226bc17b",
  null
  
)

export default component.exports